import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { Button, ButtonVariant } from "shared/components";
import { Modal } from "shared/components/Modal";
import { useConfigurableGroupMetric } from "../hooks/use-configurable-group-metric";

export const ConfirmResetMetricsModal = ({
  opened,
  onClose
}: {
  opened: boolean;
  onClose: () => void;
}) => {
  const { resetMetricsToDefault } = useConfigurableGroupMetric();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-sm p-8 text-center"
    >
      <div className="h-16 w-16 mb-6 rounded-full bg-warning-50 flex items-center justify-center mx-auto">
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={32}
          className="text-warning-600"
        />
      </div>
      <p className="text-xl font-bold mb-3">Reset to default?</p>
      <p className="text-sm font-medium text-content-400 mb-8">
        All metrics will be reset to a default view. All custom changes will be
        deleted
      </p>
      <div className="flex gap-3 w-full">
        <Button
          variant={ButtonVariant.BASE}
          onClick={onClose}
          className="w-full"
        >
          Cancel
        </Button>
        <Button
          variant={ButtonVariant.PRIMARY}
          onClick={() =>
            resetMetricsToDefault(undefined, { onSuccess: onClose })
          }
          className="w-full"
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
};
